<template>
	<span :class="'badge ' + this.size + ' ' + this.type">
		<slot></slot>
	</span>
</template>

<script type="text/babel">
export default {
	props: {
		type: { default: "regular" },
		size: { default: "normal" },
	},
};
</script>
